import { IsMediaAllowed } from './types';

// PLK allows to redeem in restaurant in all media devices
export const isMediaAllowed: IsMediaAllowed = () => true;
